// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImageV2$PorterinFeature from "../../../../ui/components/NextImageV2.mjs";
import * as HomeBannerImageModuleScss from "../styles/HomeBannerImage.module.scss";

var styles = HomeBannerImageModuleScss;

function HomeBannerImageCmp(Props) {
  var desktopBanner = Props.desktopBanner;
  var mobileBanner = Props.mobileBanner;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles.desktop
                }, React.createElement(NextImageV2$PorterinFeature.make, {
                      src: desktopBanner,
                      fill: true,
                      alt: "Banner Image",
                      priority: true,
                      className: styles.img
                    })), React.createElement("div", {
                  className: styles.mobile
                }, React.createElement(NextImageV2$PorterinFeature.make, {
                      src: mobileBanner,
                      fill: true,
                      alt: "Banner Image",
                      priority: true,
                      className: styles.img
                    })));
}

var make = HomeBannerImageCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
